const eventClickType = ('ontouchstart' in window) ? 'touchstart' : 'click';

   $(".header-items .header__icon--cart").click(function(ev) {
       ev.preventDefault();
   });

  window.addEventListener('message', handleMessage, false);
    function handleMessage(event) {
        if (event.origin != "https://formbuilder.hulkapps.com") { return; }
        switch(event.data) {
            case "HELLO_PARENT":
                window.location.href = 'https://primalice.com.au/';
                break;
        } 
    }


// NEEWWWWWW
// Cache selectors for better performance
const $firstPfSelect = $('.filters-product-dropdown .pf-variant-select').first();
const $firstProductSelect = $('.product-form__input--dropdown .select__select').first();
const $pfFiltersSelect = $('.filters-product-dropdown select[data-option-name="Filters"]');
const $productFiltersSelect = $('.product-form__input--dropdown select[name="options[Filters]"]');

// Function to enable all options
function enableAllOptions() {
  $('.product-form__input--dropdown .select__select option').removeAttr('disabled');
}

// MutationObserver to replace setInterval
function setupOptionObserver() {
  const observer = new MutationObserver(function(mutations) {
    let needsUpdate = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
        $(mutation.target).removeAttr('disabled');
        needsUpdate = true;
      }
    });
    
    // If any options were re-enabled, trigger a refresh
    if (needsUpdate) {
      // Force select refresh if needed
      $('.product-form__input--dropdown .select__select').trigger('change');
    }
  });

  // Observe all option elements for disabled attribute changes
  const options = document.querySelectorAll('.product-form__input--dropdown .select__select option');
  options.forEach(function(option) {
    observer.observe(option, { 
      attributes: true, 
      attributeFilter: ['disabled'] 
    });
  });

  return observer;
}

// Initialize MutationObserver
let optionObserver = null;
if (typeof MutationObserver !== 'undefined') {
  optionObserver = setupOptionObserver();
}

// First dropdown logic
var CurrentVal = $firstPfSelect.find(":selected").val();
var secondSelectBox = $('.pf-variant-select').eq(1);
if (CurrentVal === "Commercial") {
  secondSelectBox.prop('selectedIndex', 2);
  $('.filters-product-dropdown select[data-option-name="Filters"] option[value="4 Pack ($20 each)"]').hide();
  $('.filters-product-dropdown select[data-option-name="Filters"] option[value="10 Pack ($15 each)"]').hide();
  $('.filters-product-dropdown select[data-option-name="Filters"] option[value="4 Pack ($25 each)"]').show();
  $('.filters-product-dropdown select[data-option-name="Filters"] option[value="10 Pack ($20 each)"]').show();
} else {
  secondSelectBox.prop('selectedIndex', 0);
  $('.filters-product-dropdown select[data-option-name="Filters"] option[value="4 Pack ($25 each)"]').hide();
  $('.filters-product-dropdown select[data-option-name="Filters"] option[value="10 Pack ($20 each)"]').hide();
  $('.filters-product-dropdown select[data-option-name="Filters"] option[value="4 Pack ($20 each)"]').show();
  $('.filters-product-dropdown select[data-option-name="Filters"] option[value="10 Pack ($15 each)"]').show();
}

$firstPfSelect.on('change', function() {   
  var CurrentVal = $(this).find(":selected").val();
  var secondSelectBox = $('.pf-variant-select').eq(1);
  if (CurrentVal === "Commercial") {
    secondSelectBox.prop('selectedIndex', 2);
    $('.filters-product-dropdown select[data-option-name="Filters"] option[value="4 Pack ($20 each)"]').hide();
    $('.filters-product-dropdown select[data-option-name="Filters"] option[value="10 Pack ($15 each)"]').hide();
    $('.filters-product-dropdown select[data-option-name="Filters"] option[value="4 Pack ($25 each)"]').show();
    $('.filters-product-dropdown select[data-option-name="Filters"] option[value="10 Pack ($20 each)"]').show();
  } else {
    secondSelectBox.prop('selectedIndex', 0);
    $('.filters-product-dropdown select[data-option-name="Filters"] option[value="4 Pack ($25 each)"]').hide();
    $('.filters-product-dropdown select[data-option-name="Filters"] option[value="10 Pack ($20 each)"]').hide();
    $('.filters-product-dropdown select[data-option-name="Filters"] option[value="4 Pack ($20 each)"]').show();
    $('.filters-product-dropdown select[data-option-name="Filters"] option[value="10 Pack ($15 each)"]').show();
  }
});

// Second dropdown logic  
var CurrentVal2 = $firstProductSelect.find(":selected").val();
var secondSelectBox2 = $('.select__select').eq(1);
if (CurrentVal2 === "Commercial") {
  secondSelectBox2.prop('selectedIndex', 2);
  $('.product-form__input--dropdown select[name="options[Filters]"] option[value="4 Pack ($20 each)"]').hide();
  $('.product-form__input--dropdown select[name="options[Filters]"] option[value="10 Pack ($15 each)"]').hide();
  $('.product-form__input--dropdown select[name="options[Filters]"] option[value="4 Pack ($25 each)"]').show();
  $('.product-form__input--dropdown select[name="options[Filters]"] option[value="10 Pack ($20 each)"]').show();
} else {
  secondSelectBox2.prop('selectedIndex', 0);
  $('.product-form__input--dropdown select[name="options[Filters]"] option[value="4 Pack ($25 each)"]').hide();
  $('.product-form__input--dropdown select[name="options[Filters]"] option[value="10 Pack ($20 each)"]').hide();
  $('.product-form__input--dropdown select[name="options[Filters]"] option[value="4 Pack ($20 each)"]').show();
  $('.product-form__input--dropdown select[name="options[Filters]"] option[value="10 Pack ($15 each)"]').show();
}

$firstProductSelect.on('change', function() { 
  enableAllOptions(); // Ensure options are enabled on change
  var CurrentVal2 = $(this).find(":selected").val();
  var secondSelectBox2 = $('.select__select').eq(1);
  if (CurrentVal2 === "Commercial") {
    secondSelectBox2.prop('selectedIndex', 2);
    $('.product-form__input--dropdown select[name="options[Filters]"] option[value="4 Pack ($20 each)"]').hide();
    $('.product-form__input--dropdown select[name="options[Filters]"] option[value="10 Pack ($15 each)"]').hide();
    $('.product-form__input--dropdown select[name="options[Filters]"] option[value="4 Pack ($25 each)"]').show();
    $('.product-form__input--dropdown select[name="options[Filters]"] option[value="10 Pack ($20 each)"]').show();
  } else {
    secondSelectBox2.prop('selectedIndex', 0);
    $('.product-form__input--dropdown select[name="options[Filters]"] option[value="4 Pack ($25 each)"]').hide();
    $('.product-form__input--dropdown select[name="options[Filters]"] option[value="10 Pack ($20 each)"]').hide();
    $('.product-form__input--dropdown select[name="options[Filters]"] option[value="4 Pack ($20 each)"]').show();
    $('.product-form__input--dropdown select[name="options[Filters]"] option[value="10 Pack ($15 each)"]').show();
  }
});

// Cleanup function (optional - if you need to disconnect observer later)
function cleanupObservers() {
  if (optionObserver) {
    optionObserver.disconnect();
  }
}

// Re-initialize observer if new options are added dynamically
function refreshObserver() {
  if (optionObserver) {
    optionObserver.disconnect();
  }
  optionObserver = setupOptionObserver();
}
////////////////////

   
document.addEventListener("DOMContentLoaded", function () {
  // console.log('Document is ready');
  document.querySelector(".img_popup_openr_pdp_ud") && document.querySelector(".img_popup_openr_pdp_ud").addEventListener("click", function () {
    document.querySelector(".popup_image_ud_cstm_wrp").classList.add("active");
    document.querySelector("body").classList.add("popup_active");
    // console.log('Popup opened');
  });

  document.querySelector(".close_img_popup") && document.querySelector(".close_img_popup").addEventListener("click", function () {
    document.querySelector(".popup_image_ud_cstm_wrp").classList.remove("active");
    document.querySelector("body").classList.remove("popup_active");
    // console.log('Popup closed by close button');
  });

  document.querySelector(".overlay_popup") && document.querySelector(".overlay_popup").addEventListener("click", function () {
    document.querySelector(".popup_image_ud_cstm_wrp").classList.remove("active");
    document.querySelector("body").classList.remove("popup_active");
    console.log('Popup closed by overlay click');
  });

  document.querySelector(".popup_image_ud_cstm_wrp") && document.querySelector(".popup_image_ud_cstm_wrp").addEventListener("click", function (e) {
    if (!e.target.closest(".popum_image_inner_wrp")) {
      document.querySelector(".popup_image_ud_cstm_wrp").classList.remove("active");
      document.querySelector("body").classList.remove("popup_active");
      console.log('Popup closed by outside click');
    }
  });
});

  $(document).ready(function () {
    $('.main_reviews_wrapper .review_items_inner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
    });
  });

$('.productView-details .productView-variants .product-form__label').on('click', function () {
    var URL = $(this).attr('data-product-url');
    if (URL) {
      // console.log(URL, 'EE');
      window.location.href = URL;
    }
});


$('button.header-country-button').on('click', function(){
   $(this).toggleClass('active').next('ul.country-popup-list').toggle();
});

$(document).on('click', 'li.country-popup-item', function () {
  var DataCountry = $(this).attr('data-country');

  if (DataCountry === "AU") {
    sessionStorage.setItem("justRedirectedToAU", "true"); // flag set
    window.location.href = "https://primalice.com.au/";
    return false;
  }

  if (DataCountry === "US") {
    window.location.href = "https://primalice.com/";
    return false;
  }
});



$('.sale-banner-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  prevArrow:
    '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"></path></svg></button>',
  nextArrow:
    '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path></svg></button>',
});

document.addEventListener('DOMContentLoaded', function() {
    let scrollThreshold = 10; // pixels
    let touchStartX = 0;
    let touchStartY = 0;
    let isScrolling = false;

    document.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isScrolling = false;
    }, { passive: true });

    document.addEventListener('touchmove', function(e) {
        if (!isScrolling) {
            const touchEndX = e.touches[0].clientX;
            const touchEndY = e.touches[0].clientY;
            const deltaX = Math.abs(touchEndX - touchStartX);
            const deltaY = Math.abs(touchEndY - touchStartY);
            
            // If movement is more than threshold, consider it scrolling
            if (deltaX > scrollThreshold || deltaY > scrollThreshold) {
                isScrolling = true;
            }
        }
    }, { passive: true });

    document.addEventListener('touchend', function(e) {
        if (!isScrolling) {
            const clickedOption = e.target.closest('.tub-option');
            if (clickedOption) {
                handleOptionSelection(clickedOption, e);
            }
        }
    }, { passive: false });

    // Keep original click for desktop
    document.addEventListener('click', function(e) {
        const clickedOption = e.target.closest('.tub-option');
        if (clickedOption) {
            handleOptionSelection(clickedOption, e);
        }
    });

    function handleOptionSelection(clickedOption, e) {
        const bundleRow = clickedOption.closest('.bundle-pro-options-row');
        if (bundleRow && !clickedOption.classList.contains('selected')) {
            const currentlySelected = bundleRow.querySelector('.tub-option.selected');
            if (currentlySelected) {
                currentlySelected.classList.remove('selected');
            }
            clickedOption.classList.add('selected');
            const prdctURL = clickedOption.href;
            if (prdctURL) {
                window.location.href = prdctURL;
            }
        }
    }
});